<script>
/**
 * Transactions component
 */
export default {
  data() {
    return {
      transactionData: [
        {
          orderid: "#EI1563",
          date: "28 Mar 2020",
          billingname: "Velho Chico",
          total: "R$ 164",
          paymentstatus: "Pendente"
        },
        {
          orderid: "#EI1564",
          date: "28 Mar 2020",
          billingname: "Brsileiro Supera",
          total: "R$ 141",
          paymentstatus: "Pago"
        },
        {
          orderid: "#EI1565",
          date: "29 Mar 2020",
          billingname: "Baioano Top",
          total: "R$ 123",
          paymentstatus: "Pago"
        },
        {
          orderid: "#EI1566",
          date: "30 Mar 2020",
          billingname: "Tiradentes Brasil",
          total: "R$ 112",
          paymentstatus: "Pago"
        },
        {
          orderid: "#EI1567",
          date: "31 Mar 2020",
          billingname: "Pedro Cabral",
          total: "R$ 105",
          paymentstatus: "Pendente"
        },
        {
          orderid: "#EI1568",
          date: "01 Abr 2020",
          billingname: "Santos Dumont",
          total: "R$ 160",
          paymentstatus: "Chargeback"
        },
        {
          orderid: "#EI1569",
          date: "02 Abr 2020",
          billingname: "Airton Senna",
          total: "R$ 183",
          paymentstatus: "Pago"
        },
        {
          orderid: "#EI1570",
          date: "03 Abr 2020",
          billingname: "Jamilson Sampaio",
          total: "R$ 146",
          paymentstatus: "Pago"
        },
        {
          orderid: "#EI1571",
          date: "03 Abr 2020",
          billingname: "Edgard Santos",
          total: "R$ 165",
          paymentstatus: "Pendente"
        },
        {
          orderid: "#EI1572",
          date: "04 Abr 2020",
          billingname: "Paulo Henrique",
          total: "R$ 172",
          paymentstatus: "Pago"
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 25, 50],
      filter: null,
      filterOn: [],
      sortBy: "orderid",
      sortDesc: false,
      fields: [
        { key: "orderid", sortable: true, label: "ID" },
        { key: "date", sortable: true },
        { key: "billingname", sortable: true, label: "Cliente/Fornecedor" },
        { key: "total", sortable: true, label: "Total" },
        { key: "paymentstatus", sortable: true, label: "Pagamento" },
        { key: "action" }
      ]
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.transactionData.length;
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.transactionData.length;
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <b-dropdown right toggle-class="arrow-none card-drop" class="float-right" variant="white">
        <template v-slot:button-content>
          <i class="mdi mdi-dots-vertical"></i>
        </template>
        <!-- item-->
        <b-dropdown-item>Relatório Vendas</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item>Relatório Exportação</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item>Lucro</b-dropdown-item>
        <!-- item-->
        <b-dropdown-item>Recebíveis</b-dropdown-item>
      </b-dropdown>

      <h4 class="card-title mb-4">Últimas transações</h4>
      <div class="row mt-4">
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              Mostrar&nbsp;
              <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
            </label>
          </div>
        </div>
        <!-- Pesquisar -->
        <div class="col-sm-12 col-md-6">
          <div id="tickets-table_filter" class="dataTables_filter text-md-right">
            <label class="d-inline-flex align-items-center">
              Pesquisar:
              <b-form-input
                v-model="filter"
                type="search"
                class="form-control form-control-sm ml-2"
              ></b-form-input>
            </label>
          </div>
        </div>
        <!-- End search -->
      </div>
      <div class="table-responsive">
        <b-table
          :items="transactionData"
          :fields="fields"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :filter="filter"
          :filter-included-fields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(paymentstatus)="row">
            <div
              class="badge font-size-12"
              :class="{'badge-soft-danger': `${row.value}` === 'Chargeback',
              'badge-soft-success': `${row.value}` === 'Pago',
              'badge-soft-warning': `${row.value}` === 'Pendente'}"
            >{{ row.value}}</div>
          </template>

          <template v-slot:cell(action)>
            <a
              href="javascript:void(0);"
              class="mr-3 text-primary"
              v-b-tooltip.hover
              data-toggle="tooltip"
              title="Edit"
            >
              <i class="mdi mdi-pencil font-size-18"></i>
            </a>
            <a href="javascript:void(0);" class="text-danger" v-b-tooltip.hover title="Delete">
              <i class="mdi mdi-trash-can font-size-18"></i>
            </a>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-right">
            <ul class="pagination pagination-rounded mb-0">
              <!-- paginacao -->
              <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>